import { Component, ojs, app, state, v } from "modular-openscriptjs";
import {
    inform,
    consoleErrorOnLocal,
    scrollToTop,
    either,
} from "../../helpers";
import { api, gc } from "../../declarations";
import SolidIcon from "../Blocks/SolidIcon";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { $e } from "../../ojs.events";
import { Capacitor } from "@capacitor/core";
import { getFirebaseToken } from "../../firebase";

dayjs.extend(relativeTime);

const h = app("h");
const router = app("router");

ojs(SolidIcon);

export default class Notifications extends Component {
    notifications = state([]);
    loading = state(true);
    filter = state("all"); // 'all' or 'unread'
    pagination = state(null);


    $_mounted() {
        if (Capacitor.isNativePlatform()) {
            getFirebaseToken();
        }
    }


    render() {
        scrollToTop();

        if (this.loading.value) {
            this.fetchNotifications();
        }

        return h.div(
            { class: "min-vh-100 py-5 mb-5 py-md-5" },
            h.div(
                { class: "container" },
                // Header
                h.div(
                    {
                        class: "mb-5 d-flex align-items-center justify-content-between flex-wrap gap-4",
                    },
                    h.div(
                        { class: "d-flex align-items-center gap-3" },
                        h.button(
                            {
                                class: "btn btn-white border shadow-sm circle p-2",
                                onclick: "history.back()",
                            },
                            h.SolidIcon("arrow-left"),
                        ),
                        h.h2({ class: "fw-bold mb-0" }, "Notifications"),
                    ),
                    h.div(
                        { class: "d-flex gap-3 align-items-center" },
                        v(this.filter, (f) =>
                            h.select(
                                {
                                    class: "form-select px-4 border-0 shadow-sm",
                                    style: "min-width: 160px; height: 48px;",
                                    listeners: {
                                        change: (e) => {
                                            this.filter.value = e.target.value;
                                            this.loading.value = true;
                                            this.fetchNotifications();
                                        },
                                    },
                                },
                                h.option(
                                    {
                                        value: "all",
                                    },
                                    either(f.value == "all", {
                                        selected: true,
                                    }),
                                    "All Messages",
                                ),
                                h.option(
                                    {
                                        value: "unread",
                                    },
                                    either(f.value == "unread", {
                                        selected: true,
                                    }),
                                    "Unread Only",
                                ),
                                h.option(
                                    {
                                        value: "read",
                                    },
                                    either(f.value == "read", {
                                        selected: true,
                                    }),
                                    "Read Only",
                                ),
                            ),
                        ),
                        h.button(
                            {
                                class: "btn btn-outline-secondary px-4 fw-bold",
                                style: "height: 48px;",
                                onclick: this.method("markAllAsRead"),
                            },
                            "Mark as Read",
                        ),
                    ),
                ),

                // Notifications List
                h.div(
                    {
                        class: "bg-transparent p-0 shadow-none border-0",
                        style: "min-height: auto;",
                    },
                    v(this.loading, (l) => {
                        if (l.value)
                            return h.div(
                                { class: "text-center py-5" },
                                h.Spinner(),
                            );

                        return v(this.notifications, (notifs) => {

                            if (notifs.value.length === 0) {
                                return h.div(
                                    {
                                        class: "text-center py-5 bg-white rounded-4 shadow-sm mt-2",
                                    },
                                    h.div(
                                        { class: "text-muted mb-3 opacity-25" },
                                        h.i({
                                            class: "bi bi-bell-slash",
                                            style: "font-size: 5rem;",
                                        }),
                                    ),
                                    h.h5(
                                        { class: "fw-bold" },
                                        "No notifications found",
                                    ),
                                    h.p(
                                        { class: "text-muted mb-0" },
                                        "You're all caught up! New notifications will appear here.",
                                    ),
                                );
                            }

                            return h.div(
                                { class: "d-flex flex-column gap-3 mt-2" },
                                ...notifs.value.map((n) =>
                                    this.renderNotificationItem(n),
                                ),
                            );
                        });
                    }),
                ),
            ),
        );
    }

    renderNotificationItem(notification) {
        const isUnread = !notification.read_at;
        const data = notification.data || {};
        const actions = data.actions || [];

        if (actions.length === 0 && (data.action_url || data.url)) {
            actions.push({
                name: "View Details",
                url: data.action_url || data.url,
            });
        }

        return h.div(
            {
                class: `card border-0 rounded-4 mb-3 position-relative overflow-hidden ${
                    isUnread ? "shadow-sm" : ""
                }`,
                style: `transition: all 0.3s ease; background-color: ${isUnread ? "#ffffff" : "#fcfcfc"}; border: 1px solid ${isUnread ? "rgba(0,0,0,0.05)" : "rgba(0,0,0,0.03)"}!important;`,
            },
            isUnread
                ? h.div({
                      class: "position-absolute top-0 start-0 h-100 bg-primary",
                      style: "width: 3px;",
                  })
                : null,
            h.div(
                {
                    class: "card-body p-4 p-sm-4 p-md-4 d-flex gap-3 gap-sm-4 align-items-start",
                },
                h.div(
                    { class: "position-relative flex-shrink-0 mt-1" },
                    h.div(
                        {
                            class: `d-flex align-items-center justify-content-center rounded-circle ${
                                isUnread
                                    ? "bg-primary bg-opacity-10 text-primary"
                                    : "bg-secondary bg-opacity-10 text-secondary"
                            }`,
                            style: "width: 46px; height: 46px;",
                        },
                        h.i({
                            class: `bi ${data.icon || (isUnread ? "bi-bell-fill" : "bi-bell")} fs-5`,
                        }),
                    ),
                    isUnread
                        ? h.div({
                              class: "position-absolute bg-danger rounded-circle border border-2 border-white",
                              style: "width: 12px; height: 12px; top: 0; right: 0; transform: translate(10%, -10%);",
                          })
                        : null,
                ),
                h.div(
                    { class: "flex-fill" },
                    h.div(
                        {
                            class: "d-flex justify-content-between align-items-start mb-1",
                        },
                        h.div(
                            h.h6(
                                {
                                    class: `mb-1 ${isUnread ? "fw-bold text-dark" : "fw-semibold text-secondary"}`,
                                    style: "font-size: 1.05rem; letter-spacing: -0.01em;",
                                },
                                data.title || "Notification",
                            ),
                            h.small(
                                {
                                    class: "text-muted d-flex align-items-center gap-1 mb-2",
                                    style: "font-size: 0.8rem; font-weight: 500;",
                                },
                                dayjs(notification.created_at).fromNow(),
                            ),
                        ),
                        h.div(
                            { class: "dropdown mt-n1 me-n2" },
                            h.button(
                                {
                                    class: "btn btn-link text-muted p-2 rounded-circle text-decoration-none border-0",
                                    style: "transition: background-color 0.2s;",
                                    onmouseover:
                                        "this.style.backgroundColor='rgba(0,0,0,0.05)'",
                                    onmouseout:
                                        "this.style.backgroundColor='transparent'",
                                    data_bs_toggle: "dropdown",
                                },
                                h.i({ class: "bi bi-three-dots" }),
                            ),
                            h.ul(
                                {
                                    class: "dropdown-menu dropdown-menu-end border-0 shadow-lg rounded-4 overflow-hidden py-2",
                                    style: "min-width: 160px; z-index: 1050;",
                                },
                                isUnread
                                    ? h.li(
                                          h.button(
                                              {
                                                  class: "dropdown-item py-2 px-3 fw-medium text-primary d-flex align-items-center gap-2",

                                                  onclick: this.method(
                                                      "markAsRead",
                                                      [notification.id],
                                                  ),
                                              },
                                              h.i({
                                                  class: "bi bi-check2-all fs-5",
                                              }),
                                              "Mark as read",
                                          ),
                                      )
                                    : null,
                                h.li(
                                    h.button(
                                        {
                                            class: "dropdown-item text-danger py-2 px-3 fw-medium d-flex align-items-center gap-2",
                                            onclick: this.method(
                                                "deleteNotification",
                                                [notification.id],
                                            ),
                                        },
                                        h.i({ class: "bi bi-trash fs-5" }),
                                        "Delete",
                                    ),
                                ),
                            ),
                        ),
                    ),
                    h.p(
                        {
                            class: `mb-0 ${isUnread ? "text-dark" : "text-secondary"}`,
                            style: "font-size: 0.95rem; line-height: 1.6; opacity: 0.85;",
                        },
                        data.message || "You have a new message.",
                    ),

                    // Actions
                    actions.length > 0
                        ? h.div(
                              { class: "d-flex flex-wrap gap-2 mt-3 pt-1" },
                              ...actions.map((action) =>
                                  h.button(
                                      {
                                          class: "btn btn-primary rounded-pill px-4 py-2 fw-semibold border-0",
                                          style: "font-size: 0.85rem; box-shadow: 0 4px 10px rgba(13, 110, 253, 0.15); transition: transform 0.2s, box-shadow 0.2s;",
                                          onmouseover:
                                              "this.style.transform='translateY(-1px)'; this.style.boxShadow='0 6px 15px rgba(13, 110, 253, 0.2)'",
                                          onmouseout:
                                              "this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 10px rgba(13, 110, 253, 0.15)'",
                                          onclick: this.method(
                                              "handleActionClick",
                                              [action, notification],
                                          ),
                                      },
                                      action.name,
                                  ),
                              ),
                          )
                        : null,
                ),
            ),
        );
    }

    async fetchNotifications() {
        if (!gc.user?.id) return;
        try {
            const endpoint = `user/${gc.user.id}/notifications`;

            const res = await api.get(`${endpoint}`, {
                type: this.filter.value,
            });

            if (res) {
                this.notifications.value = res.data.notifications.data;
                this.pagination.value = res.data.notifications;
            }
        } catch (e) {
            consoleErrorOnLocal(e);
            inform("Failed to load notifications", "error");
        } finally {
            this.loading.value = false;
        }
    }

    async markAsRead(notificationId) {
        if (!gc.user?.id) return;
        try {
            const endpoint = `user/${gc.user.id}/notifications/${notificationId}/mark-as-read`;

            await api.put(endpoint);
            inform("Notification marked as read", "success");
            // Update locally
            this.notifications.value = this.notifications.value.map((n) => {
                if (n.id === notificationId) {
                    n.read_at = new Date().toISOString();
                }
                return n;
            });

            app("broker").send($e.system.needs.notificationCount);
        } catch (e) {
            consoleErrorOnLocal(e);
            inform("Failed to mark as read", "error");
        }
    }

    async markAllAsRead() {
        if (!gc.user?.id) return;
        try {
            const endpoint = `user/${gc.user.id}/notifications/mark-all-read`;

            await api.put(endpoint);
            inform("All notifications marked as read", "success");

            // Update locally immediately
            this.notifications.value = this.notifications.value.map((n) => {
                n.read_at = new Date().toISOString();
                return n;
            });

            if (this.filter.value === "unread") {
                this.loading.value = true;
                this.fetchNotifications();
            }

            app("broker").send($e.system.needs.notificationCount);
        } catch (e) {
            consoleErrorOnLocal(e);
            inform("Failed to mark all as read", "error");
        }
    }

    async deleteNotification(notificationId) {
        if (!confirm("Are you sure you want to delete this notification?"))
            return;

        const userId = gc.user?.id;
        if (!userId) return;

        try {
            const endpoint = `user/${userId}/notifications/${notificationId}`;

            await api.delete(endpoint);
            inform("Notification deleted", "success");
            // Remove locally
            this.notifications.value = this.notifications.value.filter(
                (n) => n.id !== notificationId,
            );

            app("broker").send($e.system.needs.notificationCount);
        } catch (e) {
            consoleErrorOnLocal(e);
            inform("Failed to delete notification", "error");
        }
    }

    async handleActionClick(action, notification) {
        if (!notification.read_at) {
            this.markAsRead(notification.id);
        }

        if (action.api_route) {
            const method = action.api_method || "post";
            const params = action.api_params || {};

            api[method](action.api_route, params)
                .then((res) => {
                    if (res) inform(res.message, "success");
                })
                .catch((e) => {
                    consoleErrorOnLocal(e);
                    inform("Action failed", "error");
                });
            return;
        }

        if (action.route_name) {
            router.to(action.route_name, action.route_params);
        } else if (action.url) {
            window.location.href = action.url;
        }
    }
}

ojs(Notifications);
